import Button from "@/components/Button";
import { useNavigate } from "react-router-dom";
import AVATAR from "@/assets/icons/avatar.svg";
import "./style.scss";
import { CardItemType } from "./model";
import DashboardCard from "./components/DashboardCard";
import getHomeInteractor from "@/@core/interactor/home/get-home.interactor";
import { useEffect, useState } from "react";

const Dashboard = () => {
  const navigate = useNavigate();
  const [productClaims, setProductClaims] = useState<CardItemType[]>([]);

  const sampleData: CardItemType[] = [
    {
      imgSrc: AVATAR,
      infoName: "Sheela Etele",
      infoDesc: "Jakarta, Indonesia",
      numericInfo: "$244.00",
    },
    {
      imgSrc: AVATAR,
      infoName: "Sheela Etele 1",
      infoDesc: "Jakarta, Indonesia",
      numericInfo: "$244.00",
    },
  ];

  useEffect(() => {
    getProductClaim();
  }, []);

  // const onClickNavigate = () => {
  //   navigate("/users");
  // };

  const getProductClaim = async () => {
    try {
      const response = await getHomeInteractor({
        page: 1,
        limit: 10,
        status: "owned",
      });

      const { status } = response;
      const data = response.data.data;
      if (status === 200 && data.length) {
        const temp = data.map((item) => ({
          imgSrc: item.photo_profile
            ? `${process.env.REACT_APP_API_URL}/file/${item.photo_profile}`
            : AVATAR,
          infoName: item.fullname,
          infoDesc: item?.product_name || "",
          numericInfo: "",
        }));

        setProductClaims(temp);
      } else {
        setProductClaims([]);
      }
    } catch (error: any) {
      setProductClaims([]);
    }
  };

  return (
    <div className="dashboard-page-wrapper">
      <div className="page-header">
        <div className="text-wrapper">
          <h1>DRX Dashboard</h1>
          <span className="page-description">
            Your current sales summary and activity.
          </span>
        </div>

        {/* <div>
          <Button label="Sync" size="md" startIcon="sync" />
        </div> */}
      </div>

      <div className="page-content">
        {/* <DashboardCard title="Top Customer" dataSource={sampleData} /> */}
        <DashboardCard
          title="Recent Product Claimed"
          dataSource={productClaims}
          errorText="No Claimed Product found"
        />
        {/* <DashboardCard title="Recent Trade" dataSource={sampleData} /> */}
      </div>
    </div>
  );
};

export default Dashboard;
